import React from 'react'

import { Banner, ButtonClean } from '@fourthwall/components'
import { routing } from '@utils/routing'

import { useGoogleAnalytics } from '../../hooks/useGoogleAnalytics'

export const GoogleAnalyticsBanner = () => {
  const { data } = useGoogleAnalytics()
  const status = data?.type

  // TODO: Discuss and handle other statuses

  if (status === 'FAILED' && data?.info) {
    return (
      <Banner
        appearance="danger"
        title={
          {
            MAKE_SURE_TO_BE_LOGGED_TO_PROPER_ACCOUNT:
              'We encountered problem during setup. Please make sure to use the same Google account for accepting Terms & Conditions and for account setup. Reconnect and try again.',
            MATCHING_CONFIGURATION_NOT_FOUND_FOR_MEASUREMENT_ID: (
              <>
                Google Analytics account you’ve connected ({data.email}) doesn’t have permission to
                view the Google tracking pixel you entered in{' '}
                <ButtonClean label="Site settings" to={routing.analytics.overview.trackingPixels} />
                . You can create a new tracking pixel by removing the current one or connect a
                different Google account that has access to that pixel.
              </>
            ),
            MISSING_SCOPES:
              'Missing access. Try reconnecting with Google Analytics to fix the issue. Make sure to give consent for accessing your account and data during connection process.',
          }[data.info[0].type]
        }
      />
    )
  }

  return null
}
